import { render, staticRenderFns } from "./CostAnalysisTable.vue?vue&type=template&id=72cd571c&scoped=true"
import script from "./CostAnalysisTable.vue?vue&type=script&lang=js"
export * from "./CostAnalysisTable.vue?vue&type=script&lang=js"
import style0 from "./CostAnalysisTable.vue?vue&type=style&index=0&id=72cd571c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd571c",
  null
  
)

export default component.exports